import { trace } from 'owa-trace';
import DomainServiceRequest from '../contract/DomainServiceRequest';
import DomainDataItemResponse from '../contract/DomainDataItemResponse';
import DomainDataItemRequest from '../contract/DomainDataItemRequest';
import DomainPurchaseType from '../contract/DomainPurchaseType';
import { makePostRequest } from 'owa-ows-gateway';

const createAndValidateLegacyDomainUrl: string = 'ows/api/v1/PremiumDomain/createandvalidatelegacy';

export default function domainConnectCreateAndValidateLegacyDomainService(
    domainName: string,
    purchaseType: DomainPurchaseType,
    csrfToken: string
): Promise<DomainDataItemResponse> {
    let domainDataItem: DomainDataItemRequest = {
        domainName: domainName,
        domainPurchaseType: purchaseType,
    };

    let requestObject: DomainServiceRequest = {
        domainData: domainDataItem,
        csrfToken: csrfToken,
    };

    return makePostRequest(createAndValidateLegacyDomainUrl, requestObject)
        .then(resp => {
            return resp;
        })
        .catch(err => {
            trace.warn(err);
            return null;
        });
}
